
export const colors = {
    primary: '#358CCB',
    secondary: '#2ecc71',
    tertiary: '#e67e22',
    cancel: '#fb0000'
    // Add more color constants as needed
  };